import { render, staticRenderFns } from "./puzzleVerify.vue?vue&type=template&id=4a5b58da&scoped=true&"
import script from "./puzzleVerify.vue?vue&type=script&lang=js&"
export * from "./puzzleVerify.vue?vue&type=script&lang=js&"
import style0 from "./puzzleVerify.vue?vue&type=style&index=0&id=4a5b58da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b58da",
  null
  
)

export default component.exports